document.addEventListener("latte:init", init);

function init () {
	$('.search-button-pjax').click(function (e) {
		var q = $(this).parent().find('input').val();
		if (q !== '') {
			helper.search($(this).parent().find('input').val());
			e.preventDefault();
			return false;
		}
	});

	// for sitemap page devMode
	$('#sitemap-button').click(function (e) {
		e.preventDefault();
		var url = "/sitemap?devMode=true&" + $("#sitemap-options :input[value!='']").serialize();
		window.loadUrl(url);
	});

	$('#js-prod-search-product').click(function (e) {
		$(".js-prod-search").hide();
	});

	$('#js-prod-search-page').click(function (e) {
		$(".js-prod-search").show();
	});

	if ($('#js-prod-search-product').is(':checked')) {
		$(".js-prod-search").hide();
	}
	// END sitemap page devMode

}



//////////////////
// WEBPACK FOOTER
// ./public/js/search.js
// module id = 88
// module chunks = 0